import { QUESTION_TYPES } from '@/store';

export default {
  methods: {
    getDataPointName(result) {
      if (this.questionType === QUESTION_TYPES.YES_NO) {
        if (result.value === 1) {
          return 'Yes';
        } else {
          return 'No';
        }
      } else if (
        this.questionType === QUESTION_TYPES.SLIDER ||
        this.questionType === QUESTION_TYPES.RATING ||
        this.questionType === QUESTION_TYPES.MULTI_VARIABLE_SELECT_ONE
      ) {
        return result.value;
      } else {
        return result.label;
      }
    },
    getDataLabelsFormatter() {
      return function () {
        return `<b>${this.point.name}</b>: ${this.point.y}`;
      };
    },
  },
};
